const TableDivider = () => {
        return (
            <div className="col-start-1 col-end-9 bg-slate-100 h-px"></div>
        )
};

export default TableDivider;